import { useEffect, useRef, useState } from 'react'

import cn from 'classnames'

import RefinementButton from 'components/refinement/refinement-button'

import css from './refinement-list-wrapper.module.scss'

export type FilterProps = React.ComponentProps<'div'> & {
  type: 'list' | 'disclosure'
  header: string
  isDefaultOpen?: boolean
  isSwitchOpen?: boolean
  state?: string
  wrapperClassName?: string
}

const RefinementListWrapper = ({
  type,
  header,
  isDefaultOpen = false,
  isSwitchOpen = false,
  children,
  state = '',
  wrapperClassName,
  ...divProps
}: FilterProps) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen)
  const isFirstMount = useRef(false)

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = true
      return
    }
    if (state !== '') setIsOpen(isSwitchOpen)
  }, [isSwitchOpen, state])

  return (
    <div {...divProps} className={cn([css.listContainer, isOpen && css.listOpen, wrapperClassName])}>
      <RefinementButton label={header} isOpen={isOpen} icon showSelection onClick={() => setIsOpen(!isOpen)} />
      <div
        className={css.refinementListWrapper}
        style={{ display: isOpen ? 'block' : 'none' }}
        data-test-id="list-refinement"
      >
        {children}
      </div>
    </div>
  )
}

export default RefinementListWrapper
